import { Outlet, Link } from 'react-router';

export function PublicLayout() {
  return (
    <div className="min-h-dvh flex flex-col">
      <header className="sticky top-0 z-50 bg-[var(--color-brand-surface)] border-b border-[var(--color-glam-gold-light)]/30 shadow-sm">
        <nav className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-1">
            <span className="text-xl font-bold text-[var(--color-glam-gold)]" style={{ fontFamily: 'var(--font-display)' }}>
              Glam
            </span>
            <span className="text-xl font-bold text-[var(--color-glam-pink)]" style={{ fontFamily: 'var(--font-display)' }}>
              Flops
            </span>
          </Link>
          <div className="flex items-center gap-6 text-sm font-medium">
            <Link
              to="/inventory"
              className="text-[var(--color-brand-text)] hover:text-[var(--color-brand-primary)] transition-colors"
            >
              Shop
            </Link>
            <Link
              to="/preorder"
              className="bg-[var(--color-brand-accent)] text-white px-4 py-2 rounded-full hover:opacity-90 transition-opacity"
            >
              Preorder
            </Link>
          </div>
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="bg-[var(--color-glam-black)] text-[var(--color-glam-white)] py-8">
        <div className="max-w-6xl mx-auto px-4 text-center text-sm opacity-80">
          <p>&copy; {new Date().getFullYear()} GlamFlops. Handmade with love in the Cayman Islands.</p>
        </div>
      </footer>
    </div>
  );
}
